import { graphql, useStaticQuery } from "gatsby"

export const useAllMajors = (locale) => {
  const { allCosmicjsMajors } = useStaticQuery(graphql`
    query {
      allCosmicjsMajors {
        edges {
          node {
            id
            slug
            title
            locale
            type
            content
            created_at
            published_at
            modified_at
            metadata {
              major_banner_image {
                imgix_url
              }
              major_keywords
              major_job_categories {
                title
                slug
              }
              major_pathways_filter
              major_personality_filter
              major_bachelor
              major_associate
              major_graduate
              major_master
              major_doctorate
            }
          }
        }
      }
    }
  `)

  const allItems = allCosmicjsMajors.edges.map(({ node }, index) => ({
    key: index,
    id: node.id,
    slug: node.slug,
    title: node.title,
    locale: node.locale,
    type: node.type,
    content: node.content,
    created_at: node.created_at,
    published_at: node.published_at,
    modified_at: node.modified_at,
    major_banner_image: node.metadata?.major_banner_image?.imgix_url,
    major_keywords: node.metadata?.major_keywords,
    major_job_categories: node.metadata?.major_job_categories,
    major_pathways_filter: node.metadata?.major_pathways_filter,
    major_personality_filter: node.metadata?.major_personality_filter,
    major_bachelor: node.metadata?.major_bachelor,
    major_associate: node.metadata?.major_associate,
    major_graduate: node.metadata?.major_graduate,
    major_master: node.metadata?.major_master,
    major_doctorate: node.metadata?.major_doctorate,
  }))

  if (!locale) {
    return allItems
  }

  return allItems.filter((item) => item.locale === locale)
}
